import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Form, TextArea } from 'semantic-ui-react';
import styled from 'styled-components';
// import { Upload } from '../../../components/Forms/UI/Upload';

import { SingleSelect } from '../../Forms/UI/Select';

const Column = styled(Grid.Column)``;

const MotivazioniOptions = [
  {
    value: 'Rinuncia cliente',
    label: 'Rinuncia cliente',
  },
  {
    value: 'Rifiuto banca',
    label: 'Rifiuto banca',
  },
  {
    value: 'Documentazione Kiron non conforme',
    label: 'Documentazione Kiron non conforme',
  },
  {
    value: 'Annullo tecnico',
    label: 'Annullo tecnico',
  },
];

export const BaseForm = (props) => (
  <Form autoComplete="off" onSubmit={props.handleSubmit} loading={props.isSubmitting}>
    <Grid columns="equal">
      <Grid.Row>
        <Column key="motivazione" width={16}>
          <SingleSelect
            options={MotivazioniOptions}
            value={props.values.motivo}
            onChange={props.setFieldValue}
            onBlur={(name, isTouched) => {
              props.setFieldTouched(name, isTouched);
            }}
            error={props.errors.motivo}
            touched={props.touched.motivo}
            name="motivo"
            label="Motivo"
          />
        </Column>
        <Column key="nota" width={16} style={{ marginTop: 11 }}>
          <b style={{ marginBottom: 5, display: 'inline-block' }}>Nota</b>
          <TextArea
            style={{ minHeight: 75 }}
            autoHeight
            placeholder="Inserisci la tua nota"
            value={props.values.nota}
            onChange={(e, data) => props.setFieldValue('nota', data.value)}
          />
        </Column>
      </Grid.Row>
    </Grid>
  </Form>
);

BaseForm.propTypes = {
  isSubmitting: PropTypes.bool,
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  handleSubmit: PropTypes.func,
  setFieldValue: PropTypes.func,
  setFieldTouched: PropTypes.func,
};

export default BaseForm;



// WEBPACK FOOTER //
// ./app/components/ProcessoImpresa/AnnullaPorcessoImpresa/baseForm.js